import {
  FETCH_PAYMENT_LIST_LOADING,
  FETCH_PAYMENT_LIST_DONE,
  FETCH_PAYMENT_LIST_ERROR,

  FETCH_PAYMENT_LIST_FILTER_LOADING,
  FETCH_PAYMENT_LIST_FILTER_DONE,
  FETCH_PAYMENT_LIST_FILTER_ERROR,

  FETCH_INVOICE_DETAIL_LOADING,
  FETCH_INVOICE_DETAIL_DONE,
  FETCH_INVOICE_DETAIL_ERROR,

  FETCH_PAYMENT_WAITING_LOADING,
  FETCH_PAYMENT_WAITING_DONE,
  FETCH_PAYMENT_WAITING_ERROR,

  FETCH_PAYMENT_COMPLETE_LOADING,
  FETCH_PAYMENT_COMPLETE_DONE,
  FETCH_PAYMENT_COMPLETE_ERROR,

  DOWNLOAD_INVOICE_LOADING,
  DOWNLOAD_INVOICE_DONE,
  DOWNLOAD_INVOICE_ERROR,

  CREATE_PAYMENT_LOADING,
  CREATE_PAYMENT_DONE,
  CREATE_PAYMENT_ERROR,

  PAYMENT_PROCESS_TEMP,

  FETCH_PAYMENT_PARTIAL_LOADING,
  FETCH_PAYMENT_PARTIAL_DONE,
  FETCH_PAYMENT_PARTIAL_ERROR,

  FETCH_PAYMENT_DETAIL_LOADING,
  FETCH_PAYMENT_DETAIL_DONE,
  FETCH_PAYMENT_DETAIL_ERROR,

  FETCH_PAYMENT_HISTORY_LOADING,
  FETCH_PAYMENT_HISTORY_DONE,
  FETCH_PAYMENT_HISTORY_ERROR,

  PUT_PAYMENT_PARTIAL_PROOF_LOADING,
  PUT_PAYMENT_PARTIAL_PROOF_DONE,
  PUT_PAYMENT_PARTIAL_PROOF_ERROR,

  DOWNLOAD_PROOF_LOADING,
  DOWNLOAD_PROOF_DONE,
  DOWNLOAD_PROOF_ERROR

} from './actions'

export default {
  // ------ unpaid ----- //
  [FETCH_PAYMENT_LIST_LOADING] (state) {
    state.isLoading = true
    state.error = false
  },

  [FETCH_PAYMENT_LIST_DONE] (state, items) {
    state.items = items
    state.isLoading = false
    state.error = false
  },

  [FETCH_PAYMENT_LIST_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [FETCH_PAYMENT_LIST_FILTER_LOADING] (state) {
    state.isLoading = true
    state.error = false
  },

  [FETCH_PAYMENT_LIST_FILTER_DONE] (state, items) {
    state.items = items
    state.isLoading = false
    state.error = false
  },

  [FETCH_PAYMENT_LIST_FILTER_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  // ------ waiting ----- //
  [FETCH_PAYMENT_WAITING_LOADING] (state) {
    state.isLoadingpaymentWaiting = true
    state.errorpaymentWaiting = false
  },

  [FETCH_PAYMENT_WAITING_DONE] (state, items) {
    state.paymentWaiting = items
    state.isLoadingpaymentWaiting = false
    state.errorpaymentWaiting = false
  },

  [FETCH_PAYMENT_WAITING_ERROR] (state, error) {
    state.errorpaymentWaiting = error
    state.isLoadingpaymentWaiting = false
  },

  // ------ complete ----- //
  [FETCH_PAYMENT_COMPLETE_LOADING] (state) {
    state.isLoadingpaymentComplete = true
    state.errorpaymentComplete = false
  },

  [FETCH_PAYMENT_COMPLETE_DONE] (state, items) {
    state.paymentComplete = items
    state.isLoadingpaymentComplete = false
    state.errorpaymentComplete = false
  },

  [FETCH_PAYMENT_COMPLETE_ERROR] (state, error) {
    state.errorpaymentComplete = error
    state.isLoadingpaymentComplete = false
  },

  // ------ detail ----- //
  [FETCH_INVOICE_DETAIL_LOADING] (state) {
    state.item = {}
    state.isLoading = true
    state.error = false
  },

  [FETCH_INVOICE_DETAIL_DONE] (state, item) {
    state.item = item
    state.isLoading = false
    state.error = false
  },

  [FETCH_INVOICE_DETAIL_ERROR] (state, error) {
    state.item = {}
    state.error = error
    state.isLoading = false
  },

  [DOWNLOAD_INVOICE_LOADING] (state) {
    state.isDownloading = true
  },
  [DOWNLOAD_INVOICE_DONE] (state, items) {
    state.isDownloading = false
  },
  [DOWNLOAD_INVOICE_ERROR] (state, error) {
    state.errorDownloading = error
    state.isDownloading = false
  },

  [CREATE_PAYMENT_LOADING] (state) {
    state.isLoadingCreatePayment = true
  },

  [CREATE_PAYMENT_DONE] (state, item) {
    state.createPayment = item
    state.isLoadingCreatePayment = false
    state.errorCreatePayment = false
  },

  [CREATE_PAYMENT_ERROR] (state, error) {
    state.errorCreatePayment = error
    state.createPayment = null
    state.isLoadingCreatePayment = false
  },

  [PAYMENT_PROCESS_TEMP] (state, items) {
    state.dataTemp = items
  },

  [FETCH_PAYMENT_PARTIAL_LOADING] (state) {
    state.isLoadingpaymentPartial = true
    state.errorpaymentPartial = false
  },
  [FETCH_PAYMENT_PARTIAL_DONE] (state, items) {
    state.paymentPartial = items
    state.isLoadingpaymentPartial = false
    state.errorpaymentPartial = false
  },
  [FETCH_PAYMENT_PARTIAL_ERROR] (state, error) {
    state.errorpaymentPartial = error
    state.isLoadingpaymentPartial = false
  },

  [FETCH_PAYMENT_DETAIL_LOADING] (state) {
    state.isLoadingPaymentDetail = true
  },
  [FETCH_PAYMENT_DETAIL_DONE] (state, items) {
    state.getPaymentDetail = items
    state.isLoadingPaymentDetail = false
    state.errorPaymentHistory = false
  },
  [FETCH_PAYMENT_DETAIL_ERROR] (state, error) {
    state.errorPaymentDetail = error
    state.isLoadingPaymentDetail = false
  },

  [FETCH_PAYMENT_HISTORY_LOADING] (state) {
    state.isLoadingPaymentHistory = true
  },
  [FETCH_PAYMENT_HISTORY_DONE] (state, items) {
    state.getPaymentHistory = items
    state.isLoadingPaymentHistory = false
    state.errorPaymentHistory = false
  },
  [FETCH_PAYMENT_HISTORY_ERROR] (state, error) {
    state.errorPaymentHistory = error
    state.isLoadingPaymentHistory = false
  },

  [PUT_PAYMENT_PARTIAL_PROOF_LOADING] (state) {
    state.isLoadingPartialProof = true
  },
  [PUT_PAYMENT_PARTIAL_PROOF_DONE] (state, items) {
    state.putPartialProof = items
    state.isLoadingPartialProof = false
    state.errorPartialProof = false
  },
  [PUT_PAYMENT_PARTIAL_PROOF_ERROR] (state, error) {
    state.errorPartialProof = error
    state.isLoadingPartialProof = false
  },

  [DOWNLOAD_PROOF_LOADING] (state) {
    state.isDownloading = true
  },
  [DOWNLOAD_PROOF_DONE] (state, items) {
    state.isDownloading = false
    state.errorDownloading = null
  },
  [DOWNLOAD_PROOF_ERROR] (state, error) {
    state.errorDownloading = error
    state.isDownloading = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/mutations.js